import React from 'react';
import CartIcon from './cart/CartIcon';
class Cart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCart: false,
      cartLoad: true,
      cartUpdate: false,
      cartEmpty: false,
      cartPulse: false,
    };
  }

  handleChange = () => {
    setTimeout(() => {
      this.setState(state => ({
        cartLoad: !state.cartLoad,
        cartUpdate: !state.cartUpdate,
        cartEmpty: !state.cartEmpty,
        cartPulse: true,
      }));
    }, 2000);

    setTimeout(() => {
      this.setState(state => Object.assign({}, state, { cartPulse: false }));
    }, 3000);
  };
  render() {
    return (
      <div onClick={this.handleChange} className="cart_container">
        <CartIcon
          loading={this.state.cartLoad}
          update={this.state.cartUpdate}
          empty={this.state.cartEmpty}
          pulse={this.state.cartPulse}
        />
        <svg
          className={
            this.state.cartLoad === true ? 'cart-disabled cfa-icon' : 'cfa-icon'
          }
          viewBox="0 0 25 28"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Icon/Tab-Bar/My-Order/Red</title>
          <desc>Created with Sketch.</desc>
          <defs></defs>
          <g
            id="ICONS"
            stroke="none"
            strokeWidth="1"
            fillRule="evenodd"
            transform="translate(-733.000000, -384.000000)"
          >
            <g
              id="Icon/Tab-Bar/My-Order/Red"
              transform="translate(733.000000, 384.000000)"
            >
              <g>
                <path
                  d="M22.74,0.75 L13.54,0.75 L13.54,1.5 C13.5999673,2.46554926 13.1188958,3.38455342 12.2912738,3.88547582 C11.4636517,4.38639821 10.4263483,4.38639821 9.59872624,3.88547582 C8.77110423,3.38455342 8.29003265,2.46554926 8.35,1.5 L8.35,0.75 L2.61,0.75 L0.48,28 L24.87,28 L22.74,0.75 Z M2.11,26.48 L4,2.25 L6.91,2.25 C7.27310681,4.18974729 8.96655983,5.59561283 10.94,5.59561283 C12.9134402,5.59561283 14.6068932,4.18974729 14.97,2.25 L18.47,2.25 L16.36,26.48 L2.11,26.48 Z M17.87,26.48 L18.43,20.11 C18.5209616,20.2800821 18.6971406,20.3873215 18.89,20.39 C19.1882338,20.39 19.43,20.1482338 19.43,19.85 C19.43,19.5517662 19.1882338,19.31 18.89,19.31 C18.7301669,19.3114312 18.5795163,19.3849194 18.48,19.51 L18.72,16.74 C18.7762975,16.7491473 18.8337025,16.7491473 18.89,16.74 C19.1882338,16.74 19.43,16.4982338 19.43,16.2 C19.43,15.9017662 19.1882338,15.66 18.89,15.66 L18.81,15.66 L19,13.12 C19.2208939,13.0667339 19.3832561,12.8785869 19.403624,12.6522762 C19.423992,12.4259655 19.2978333,12.2118515 19.09,12.12 L19.35,9.19 C19.3637423,9.12067446 19.3637423,9.04932554 19.35,8.98 C19.3520155,8.95337142 19.3520155,8.92662858 19.35,8.9 L20,2.25 L21.38,2.25 L22.43,15.85 C22.3345685,15.949642 22.2808965,16.082033 22.28,16.22 C22.2807777,16.385063 22.3584162,16.54034 22.49,16.64 L22.7,19.32 C22.4072891,19.3420914 22.1879086,19.5972891 22.21,19.89 C22.2320914,20.1827109 22.4872891,20.4020914 22.78,20.38 L23,23 C22.9437025,22.9908527 22.8862975,22.9908527 22.83,23 C22.5317662,23 22.29,23.2417662 22.29,23.54 C22.29,23.8382338 22.5317662,24.08 22.83,24.08 C22.9179114,24.078179 23.0039254,24.0540951 23.08,24.01 L23.28,26.56 L17.87,26.48 Z"
                  id="Shape"
                  fillRule="nonzero"
                ></path>
                <circle
                  id="Oval"
                  fillRule="nonzero"
                  cx="20.82"
                  cy="3.57"
                  r="1"
                ></circle>
                <circle
                  id="Oval"
                  fillRule="nonzero"
                  cx="20.82"
                  cy="7.18"
                  r="1"
                ></circle>
                <circle
                  id="Oval"
                  fillRule="nonzero"
                  cx="20.82"
                  cy="10.8"
                  r="1"
                ></circle>
                <circle
                  id="Oval"
                  fillRule="nonzero"
                  cx="20.82"
                  cy="14.42"
                  r="1"
                ></circle>
                <circle
                  id="Oval"
                  fillRule="nonzero"
                  cx="20.82"
                  cy="18.03"
                  r="1"
                ></circle>
                <circle
                  id="Oval"
                  fillRule="nonzero"
                  cx="18.9"
                  cy="23.46"
                  r="1"
                ></circle>
                <circle
                  id="Oval"
                  fillRule="nonzero"
                  cx="20.82"
                  cy="21.65"
                  r="1"
                ></circle>
                <circle
                  id="Oval"
                  fillRule="nonzero"
                  cx="20.82"
                  cy="25.26"
                  r="1"
                ></circle>
              </g>
            </g>
          </g>
        </svg>
      </div>
    );
  }
}

export default Cart;
